import { AxiosInstance } from 'axios';
import { DataFetcherFunction } from '@/compiler/types';
import baseAxios, { fetchPaginatedDataFunction } from '@/helpers/forms/axios';

export interface PackagePresetDimensions {
    length_mm: number
    width_mm: number
    height_mm: number
}

export interface PackagePresetResponse {
    uuid: string
    created_at: string
    updated_at: string
    owner_uuid: string
    name: string
    dimensions: PackagePresetDimensions
    is_deleted: boolean
}

export default (axios: AxiosInstance = baseAxios): { fetchPackagePresets: () => DataFetcherFunction<PackagePresetResponse>; createPackagePreset: (name: string, dimensions: PackagePresetDimensions) => Promise<PackagePresetResponse>; updatePackagePreset: (uuid: string, name: string, dimensions: PackagePresetDimensions) => Promise<PackagePresetResponse>; deletePackagePreset: (uuid: string) => Promise<void>; } => ({
    fetchPackagePresets: (): DataFetcherFunction<PackagePresetResponse> => {
        return fetchPaginatedDataFunction<PackagePresetResponse>('/api/package-presets', undefined, axios);
    },

    createPackagePreset: async (
        name: string,
        dimensions: PackagePresetDimensions,
    ): Promise<PackagePresetResponse> => {
        const response = await axios.post<{ data: PackagePresetResponse }>('/api/package-presets', {
            name,
            dimensions,
        });

        return response.data.data;
    },

    updatePackagePreset: async (
        uuid: string,
        name: string,
        dimensions: PackagePresetDimensions,
    ): Promise<PackagePresetResponse> => {
        const response = await axios.put<{ data: PackagePresetResponse }>(`/api/package-presets/${uuid}`, {
            name,
            dimensions,
        });

        return response.data.data;
    },

    deletePackagePreset: async (uuid: string): Promise<void> => {
        await axios.delete(`/api/package-presets/${uuid}`);
    },
});
